var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export var DotIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "m 14.473641,11.125485 c 0,3.106602 -2.518398,5.625 -5.6249996,5.625 -3.1066017,0 -5.625,-2.518398 -5.625,-5.625 0,-3.1066013 2.5183983,-5.6249996 5.625,-5.6249996 3.1066016,0 5.6249996,2.5183983 5.6249996,5.6249996 z" }))); };
//# sourceMappingURL=DotIcon.js.map